import React from 'react';
import { Section } from './ui/Section';
import { CTAButton } from './ui/CTAButton';
import { motion } from 'framer-motion';
import { BookOpen, Shield, Target, Users } from 'lucide-react';
export function ProgramBreakdown() {
  return <>
      <Section className="bg-white" data-id="element-164">
        <div className="text-center mb-16" data-id="element-165">
          <h2 className="text-4xl font-serif text-[#0f4c3a] mb-6" data-id="element-166">
            Qué incluye ABUNDANCIA & DINERO
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-167">
            Dentro vas a hacer 3 cosas, en este orden: Cortar el sabotaje
            interno, Alinear intención + emoción + acción, e Instalar un sistema
            simple.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-168">
          <div className="space-y-8" data-id="element-169">
            {[{
            title: "Reprogramación del 'chip de escasez'",
            desc: '(creencias heredadas)'
          }, {
            title: 'Ejercicios para romper la culpa',
            desc: 'por querer más'
          }, {
            title: 'Ley de atracción financiera aplicada',
            desc: '(sin humo: acción alineada)'
          }, {
            title: 'Sistema 50/30/20 adaptado',
            desc: 'para tu realidad'
          }, {
            title: 'Hábitos para sostener orden',
            desc: 'y crecimiento'
          }, {
            title: 'Enfoque para salir de supervivencia',
            desc: 'y construir estabilidad'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: i * 0.1
          }} className="flex gap-4" data-id="element-170">
                <div className="w-2 h-2 rounded-full bg-[#d4af37] mt-2.5 flex-shrink-0" data-id="element-171" />
                <div data-id="element-172">
                  <span className="font-bold text-[#0f4c3a]" data-id="element-173">{item.title}</span>
                  <span className="text-slate-600 block" data-id="element-174">{item.desc}</span>
                </div>
              </motion.div>)}

            <div className="pt-6" data-id="element-175">
              <p className="text-xl font-serif text-[#0f4c3a] italic" data-id="element-176">
                No es teoría bonita. Es identidad + estructura.
              </p>
            </div>
          </div>

          <div className="bg-[#fcfbf7] p-8 rounded-2xl border border-[#d4af37]/20 relative" data-id="element-177">
            <div className="absolute -top-4 -right-4 w-20 h-20 bg-[#d4af37] rounded-full opacity-10 blur-xl" data-id="element-178" />
            <img src="https://cdn.magicpatterns.com/uploads/3mPw2ZWogtMmtJ5ZB9R4tT/Abundancia_y_Dinero_Libro.png" alt="Material del programa" className="w-full h-auto drop-shadow-xl transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-179" />
          </div>
        </div>
      </Section>

      <Section className="bg-[#f0f7f4]" data-id="element-180">
        <h2 className="text-3xl font-serif text-[#0f4c3a] text-center mb-12" data-id="element-181">
          Si te estás diciendo 'sí, pero…'
          <span className="block text-lg font-sans text-slate-500 font-normal mt-2" data-id="element-182">
            (porque sé lo que estás pensando)
          </span>
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-183">
          {[{
          q: 'Yo no soy constante.',
          a: 'Justo por eso necesitas un sistema que funcione cuando no estás motivada.'
        }, {
          q: 'A mí me cuesta ahorrar.',
          a: 'No es falta de ganas: es que nadie te enseñó a tapar fugas + regular impulsos.'
        }, {
          q: 'Me da culpa querer más.',
          a: 'Eso no te hace mala persona. Te hace humana… y lista para sanar esa creencia.'
        }, {
          q: "No quiero vivir de 'vibrar alto'.",
          a: 'Perfecto: aquí no se trata de desear. Se trata de sostener.'
        }].map((obj, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-[#0f4c3a]/5" data-id="element-184">
              <p className="font-serif text-[#0f4c3a] font-bold text-lg mb-2" data-id="element-185">
                "{obj.q}"
              </p>
              <p className="text-slate-600" data-id="element-186">{obj.a}</p>
            </div>)}
        </div>
      </Section>

      <Section dark data-id="element-187">
        <div className="text-center max-w-3xl mx-auto" data-id="element-188">
          <h2 className="text-3xl font-serif text-[#d4af37] mb-8" data-id="element-189">
            Para quién NO es
          </h2>

          <div className="space-y-4 mb-12" data-id="element-190">
            {['Si quieres un milagro sin cambiar hábitos.', "Si buscas solo 'manifestar' sin estructura.", 'Si quieres resultados sin consistencia.'].map((item, i) => <div key={i} className="bg-white/5 p-4 rounded-lg text-white" data-id="element-191">
                {item}
              </div>)}
          </div>

          <p className="text-xl text-white font-medium" data-id="element-192">
            Esto es para mujeres que están cansadas, sí… pero listas para
            construir.
          </p>
        </div>
      </Section>
    </>;
}